import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QRCodeCanvas } from "qrcode.react";

import SideMenu from "../../components/SideMenu";
import Quotes from "../../components/Quotes";
import Footer from "../../components/Footer";

import AccountManagerService from "../../services/Celcoin/accountManagerService";
import UtilService from "../../services/Celcoin/utilService";
import { getTranslations } from "../../services/languageUtils";

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      translations: {},
      twoFactorEnabled: false,
      showSetup2FA: false,
      otpauthUrl: "",
      setupCode: "",
      loadingSetup2FA: false,
      showPasswordModal: false,
      showCurrentQRCode: false,
      userPassword: "",
      loadingQRCode: false,
      currentOtpauthUrl: "",
      isSetupMode: false,
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      password2FACode: "",
      showChangePassword2FAModal: false,
      loadingChangePassword: false,
    };
    this.textareaRef = React.createRef();
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  deactivate() {
    AccountManagerService.deactivateAccount({
      status: "BLOQUEADO",
      reason: this.textareaRef.current.value,
    })
      .then((res) => {
        UtilService.logout();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  destroy() {
    AccountManagerService.destroyAccount({
      account: "",
      documentNumber: "",
      reason: this.textareaRef.current.value,
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  toastMessage = (type, message) => {
    return toast(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: type,
      theme: "light",
    });
  };

  startSetup2FA = async () => {
    this.requestPasswordForSetup();
  };

  requestPasswordForSetup = () => {
    this.setState({
      showPasswordModal: true,
      userPassword: "",
      isSetupMode: true,
    });
  };

  executeSetup2FA = async () => {
    if (!this.state.userPassword) {
      return this.toastMessage("error", "Digite sua senha");
    }

    this.setState({ loadingSetup2FA: true });

    try {
      const response = await UtilService.createMFA(
        sessionStorage.getItem("emailUser"),
        this.state.userPassword,
      );

      this.setState({
        showPasswordModal: false,
        showSetup2FA: true,
        otpauthUrl: response.otpauthUrl,
        loadingSetup2FA: false,
        userPassword: "",
        isSetupMode: false,
      });
    } catch (error) {
      this.setState({ loadingSetup2FA: false, loadingQRCode: false });
      const status = error?.response?.status;
      if (status === 409) {
        this.toastMessage("error", "2FA já está configurado para esta conta.");
      } else {
        this.toastMessage(
          "error",
          "Senha inválida ou erro ao gerar QR Code para 2FA.",
        );
      }
    }
  };

  confirmSetup2FA = async () => {
    if (this.state.setupCode.length !== 6) {
      return this.toastMessage("error", "Digite o código de 6 dígitos");
    }

    try {
      await UtilService.verify2FA(
        sessionStorage.getItem("emailUser"),
        this.state.setupCode,
      );

      this.setState({
        twoFactorEnabled: true,
        showSetup2FA: false,
        setupCode: "",
        otpauthUrl: "",
      });

      this.toastMessage("success", "2FA configurado com sucesso!");
    } catch (error) {
      this.toastMessage("error", "Código inválido. Tente novamente.");
    }
  };

  requestPasswordForQR = () => {
    this.setState({
      showPasswordModal: true,
      userPassword: "",
      isSetupMode: false,
    });
  };

  getExistingQRCode = async () => {
    if (!this.state.userPassword) {
      return this.toastMessage("error", "Digite sua senha");
    }

    this.setState({ loadingQRCode: true });

    try {
      const response = await UtilService.createMFA(
        sessionStorage.getItem("emailUser"),
        this.state.userPassword,
      );

      this.setState({
        showPasswordModal: false,
        showCurrentQRCode: true,
        currentOtpauthUrl: response.otpauthUrl,
        loadingQRCode: false,
        userPassword: "",
      });
    } catch (error) {
      this.setState({ loadingQRCode: false });
      const status = error?.response?.status;
      if (status === 409) {
        this.toastMessage(
          "error",
          "2FA já está configurado. O QR Code original não pode ser exibido novamente por segurança.",
        );
      } else {
        this.toastMessage("error", "Senha inválida ou erro ao obter QR Code");
      }
    }
  };

  openChangePassword2FAModal = () => {
    const { currentPassword, newPassword, confirmNewPassword } = this.state;

    if (!currentPassword || !newPassword || !confirmNewPassword) {
      return this.toastMessage(
        "error",
        "Preencha todos os campos para alterar a senha.",
      );
    }

    if (newPassword !== confirmNewPassword) {
      return this.toastMessage(
        "error",
        "A confirmação da nova senha não confere.",
      );
    }

    this.setState({
      showChangePassword2FAModal: true,
      password2FACode: "",
    });
  };

  changePasswordWith2FA = async () => {
    const { currentPassword, newPassword, password2FACode } = this.state;

    if (password2FACode.length !== 6) {
      return this.toastMessage(
        "error",
        "Digite um código 2FA válido com 6 dígitos.",
      );
    }

    this.setState({ loadingChangePassword: true });

    try {
      await UtilService.changePasswordWith2FA(
        currentPassword,
        newPassword,
        password2FACode,
      );

      this.setState({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        password2FACode: "",
        showChangePassword2FAModal: false,
        loadingChangePassword: false,
      });

      this.toastMessage("success", "Senha alterada com sucesso.");
    } catch (error) {
      this.setState({ loadingChangePassword: false });
      this.toastMessage(
        "error",
        "Não foi possível alterar a senha. Verifique sua senha atual e o código 2FA.",
      );
    }
  };

  render() {
    const t = this.state.translations;
    const busy2FA = this.state.loadingSetup2FA || this.state.loadingQRCode;
    const inputClass =
      "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-customGreen focus:outline-none focus:ring-2 focus:ring-customGreen/30 disabled:bg-gray-100";
    const primaryButton =
      "inline-flex items-center justify-center rounded-md bg-customGreen px-4 py-2 text-sm font-semibold text-white hover:bg-customGreenHover focus:outline-none focus-visible:ring-2 focus-visible:ring-customGreen/40 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300";
    const secondaryButton =
      "inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-customGreen/40 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60";
    const codeInputClass =
      "w-full rounded-md border border-gray-300 px-3 py-3 text-center text-2xl font-semibold tracking-[0.5em] text-gray-900 focus:border-customGreen focus:outline-none focus:ring-2 focus:ring-customGreen/30 disabled:bg-gray-100";
    const onlyDigits = (value) => value.replace(/\D/g, "").substring(0, 6);

    return (
      <section id="userPage" className="userPage transactionPage statementPage">
        <SideMenu />

        <div className="contentData">
          <div className="contentScroll">
            <Quotes />
            <p className="breadcrumb">
              <b>
                <span className="textPrimary">{t.home} </span> |{" "}
                {t.settingsAndSecurity}
              </b>
            </p>
            <br />
            <p className="title">{t.settingsAndSecurity}</p>

            {/*
              Cada seção é uma linha: à esquerda o que é e por que importa, à direita a
              ação. Segurança e encerramento de conta ficam em blocos separados — o segundo
              é irreversível e não pode parecer só mais um formulário.
            */}
            <div className="mt-6 max-w-4xl divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white">
              <div className="grid gap-6 p-6 md:grid-cols-[minmax(0,240px)_1fr]">
                <div>
                  <h2 className="text-base font-semibold text-gray-900">
                    {t.twoFactorAuthentication || "Autenticação de dois fatores"}
                  </h2>
                  <p className="mt-1 text-sm leading-relaxed text-gray-500">
                    Um código do seu aplicativo autenticador é pedido em toda
                    transferência e na troca de senha.
                  </p>
                </div>
                <div className="flex flex-col justify-center gap-4">
                  <p className="text-sm leading-relaxed text-gray-600">
                    Use Google Authenticator, Microsoft Authenticator ou Authy.
                    Para configurar ou rever o QR Code, sua senha é solicitada.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <button
                      type="button"
                      onClick={this.startSetup2FA}
                      disabled={busy2FA}
                      className={primaryButton}
                    >
                      {this.state.loadingSetup2FA
                        ? "Processando..."
                        : t.enable2FA || "Configurar 2FA"}
                    </button>
                    <button
                      type="button"
                      onClick={this.requestPasswordForQR}
                      disabled={busy2FA}
                      className={secondaryButton}
                    >
                      {t.showQRCode || "Ver QR Code existente"}
                    </button>
                  </div>
                </div>
              </div>

              <div className="grid gap-6 p-6 md:grid-cols-[minmax(0,240px)_1fr]">
                <div>
                  <h2 className="text-base font-semibold text-gray-900">
                    {t.changePassword || "Alterar senha"}
                  </h2>
                  <p className="mt-1 text-sm leading-relaxed text-gray-500">
                    {t.changePasswordWith2FA ||
                      "Informe a senha atual e a nova. O código 2FA é pedido em seguida."}
                  </p>
                </div>
                <form
                  className="grid gap-4 sm:grid-cols-2"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (!this.state.loadingChangePassword) {
                      this.openChangePassword2FAModal();
                    }
                  }}
                >
                  <label className="block sm:col-span-2">
                    <span className="mb-1 block text-sm font-medium text-gray-700">
                      {t.currentPassword || "Senha atual"}
                    </span>
                    <input
                      type="password"
                      autoComplete="current-password"
                      value={this.state.currentPassword}
                      onChange={(e) =>
                        this.setState({ currentPassword: e.target.value })
                      }
                      className={inputClass}
                      disabled={this.state.loadingChangePassword}
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-medium text-gray-700">
                      {t.newPassword || "Nova senha"}
                    </span>
                    <input
                      type="password"
                      autoComplete="new-password"
                      value={this.state.newPassword}
                      onChange={(e) =>
                        this.setState({ newPassword: e.target.value })
                      }
                      className={inputClass}
                      disabled={this.state.loadingChangePassword}
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-medium text-gray-700">
                      {t.confirmNewPassword || "Confirmar nova senha"}
                    </span>
                    <input
                      type="password"
                      autoComplete="new-password"
                      value={this.state.confirmNewPassword}
                      onChange={(e) =>
                        this.setState({ confirmNewPassword: e.target.value })
                      }
                      className={inputClass}
                      disabled={this.state.loadingChangePassword}
                    />
                  </label>
                  {this.state.confirmNewPassword &&
                  this.state.newPassword !== this.state.confirmNewPassword ? (
                    <p className="text-sm text-red-700 sm:col-span-2">
                      A confirmação não confere com a nova senha.
                    </p>
                  ) : null}
                  <div className="sm:col-span-2">
                    <button
                      type="submit"
                      disabled={this.state.loadingChangePassword}
                      className={primaryButton}
                    >
                      {this.state.loadingChangePassword
                        ? "Processando..."
                        : t.updatePassword || "Atualizar senha"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="mt-8 max-w-4xl rounded-lg border border-red-200 bg-white">
              <div className="grid gap-6 p-6 md:grid-cols-[minmax(0,240px)_1fr]">
                <div>
                  <h2 className="text-base font-semibold text-red-800">
                    {t.manageAccount}
                  </h2>
                  <p className="mt-1 text-sm leading-relaxed text-gray-500">
                    Desativar bloqueia o acesso à conta. Excluir não pode ser
                    desfeito.
                  </p>
                </div>
                <div className="flex flex-col gap-4">
                  <textarea
                    ref={this.textareaRef}
                    placeholder={t.describeReasonHere}
                    rows="4"
                    className={inputClass + " resize-y"}
                  />
                  <div className="flex flex-wrap gap-3">
                    <button
                      type="button"
                      onClick={() => this.deactivate()}
                      className="inline-flex items-center justify-center rounded-md border border-red-300 bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-300 focus-visible:ring-offset-2"
                    >
                      {t.deactivateAccount}
                    </button>
                    <button
                      type="button"
                      onClick={() => this.destroy()}
                      className="inline-flex items-center justify-center rounded-md bg-red-700 px-4 py-2 text-sm font-semibold text-white hover:bg-red-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-300 focus-visible:ring-offset-2"
                    >
                      {t.deleteAccount}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {this.state.showSetup2FA && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                <div
                  role="dialog"
                  aria-modal="true"
                  className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl"
                >
                  <h3 className="text-lg font-semibold text-gray-900">
                    {t.setup2FA || "Configurar 2FA"}
                  </h3>
                  {this.state.otpauthUrl && (
                    <>
                      <p className="mt-1 text-sm text-gray-500">
                        {t.scanQRCode ||
                          "Escaneie o QR Code com seu aplicativo autenticador e digite o código gerado."}
                      </p>
                      <div className="my-5 flex justify-center rounded-md border border-gray-200 p-3">
                        <QRCodeCanvas
                          value={this.state.otpauthUrl}
                          size={184}
                          level="M"
                          includeMargin={false}
                        />
                      </div>
                      <input
                        type="text"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        aria-label="Código de 6 dígitos"
                        placeholder="000000"
                        value={this.state.setupCode}
                        onChange={(e) =>
                          this.setState({ setupCode: onlyDigits(e.target.value) })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && this.state.setupCode.length === 6) {
                            this.confirmSetup2FA();
                          }
                        }}
                        className={codeInputClass}
                        maxLength={6}
                      />
                    </>
                  )}
                  <div className="mt-6 flex justify-end gap-3">
                    <button
                      type="button"
                      onClick={() =>
                        this.setState({
                          showSetup2FA: false,
                          setupCode: "",
                          otpauthUrl: "",
                        })
                      }
                      className={secondaryButton}
                    >
                      {t.cancel || "Cancelar"}
                    </button>
                    {this.state.otpauthUrl && (
                      <button
                        type="button"
                        onClick={() => this.confirmSetup2FA()}
                        disabled={this.state.setupCode.length !== 6}
                        className={primaryButton}
                      >
                        {t.confirm || "Confirmar"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {this.state.showPasswordModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                <div
                  role="dialog"
                  aria-modal="true"
                  className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl"
                >
                  <h3 className="text-lg font-semibold text-gray-900">
                    Confirme sua senha
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    {this.state.isSetupMode
                      ? "Digite sua senha para configurar o 2FA."
                      : "Digite sua senha para ver o QR Code do 2FA."}
                  </p>
                  <input
                    type="password"
                    autoComplete="current-password"
                    autoFocus
                    aria-label="Sua senha"
                    value={this.state.userPassword}
                    onChange={(e) => this.setState({ userPassword: e.target.value })}
                    placeholder="Sua senha"
                    disabled={busy2FA}
                    className={inputClass + " mt-5"}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && this.state.userPassword) {
                        this.state.isSetupMode
                          ? this.executeSetup2FA()
                          : this.getExistingQRCode();
                      }
                    }}
                  />
                  <div className="mt-6 flex justify-end gap-3">
                    <button
                      type="button"
                      onClick={() =>
                        this.setState({ showPasswordModal: false, userPassword: "" })
                      }
                      disabled={busy2FA}
                      className={secondaryButton}
                    >
                      {t.cancel || "Cancelar"}
                    </button>
                    <button
                      type="button"
                      onClick={
                        this.state.isSetupMode
                          ? this.executeSetup2FA
                          : this.getExistingQRCode
                      }
                      disabled={busy2FA || !this.state.userPassword}
                      className={primaryButton}
                    >
                      {busy2FA ? "Verificando..." : t.confirm || "Confirmar"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {this.state.showCurrentQRCode && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                <div
                  role="dialog"
                  aria-modal="true"
                  className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl"
                >
                  <h3 className="text-lg font-semibold text-gray-900">
                    Seu QR Code 2FA
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    Escaneie para usar o mesmo 2FA em outro aparelho ou aplicativo.
                  </p>
                  <div className="my-5 flex justify-center rounded-md border border-gray-200 p-3">
                    <QRCodeCanvas
                      value={this.state.currentOtpauthUrl}
                      size={184}
                      level="M"
                      includeMargin={false}
                    />
                  </div>
                  <div className="flex justify-end">
                    <button
                      type="button"
                      onClick={() =>
                        this.setState({ showCurrentQRCode: false, currentOtpauthUrl: "" })
                      }
                      className={primaryButton}
                    >
                      {t.close || "Fechar"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {this.state.showChangePassword2FAModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                <div
                  role="dialog"
                  aria-modal="true"
                  className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl"
                >
                  <h3 className="text-lg font-semibold text-gray-900">
                    {t.twoFactorAuthentication || "Autenticação de dois fatores"}
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    {t.enterCodeFromApp ||
                      "Digite o código de 6 dígitos do seu aplicativo autenticador."}
                  </p>
                  <input
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus
                    aria-label="Código de 6 dígitos"
                    value={this.state.password2FACode}
                    onChange={(e) =>
                      this.setState({ password2FACode: onlyDigits(e.target.value) })
                    }
                    placeholder="000000"
                    disabled={this.state.loadingChangePassword}
                    className={codeInputClass + " mt-5"}
                    maxLength={6}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        this.state.password2FACode.length === 6 &&
                        !this.state.loadingChangePassword
                      ) {
                        this.changePasswordWith2FA();
                      }
                    }}
                  />
                  <div className="mt-6 flex justify-end gap-3">
                    <button
                      type="button"
                      onClick={() =>
                        this.setState({
                          showChangePassword2FAModal: false,
                          password2FACode: "",
                        })
                      }
                      disabled={this.state.loadingChangePassword}
                      className={secondaryButton}
                    >
                      {t.cancel || "Cancelar"}
                    </button>
                    <button
                      type="button"
                      onClick={() => this.changePasswordWith2FA()}
                      disabled={
                        this.state.loadingChangePassword ||
                        this.state.password2FACode.length !== 6
                      }
                      className={primaryButton}
                    >
                      {this.state.loadingChangePassword
                        ? "Processando..."
                        : t.updatePassword || "Atualizar senha"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <Footer />
          </div>
        </div>
        <ToastContainer />
      </section>
    );
  }
}

export default Page;
